module.exports = __webpack_public_path__ + "img/stock0.cbee8213.png";